<template>
  <div>
    <!-- 共通ヘッダー（タイトル/サブタイトル） -->
    <div class="content-header">
      <h1 class="page-title">
        <i class="fas fa-magnifying-glass"></i>
        避難元避難先（医療機関等）
      </h1>
    </div>
    <error-message :error-object="errorObject" />
    <section>
      <!-- 検索部 -->
      <details :open="isOpen" ref="facility_search_vul_search">
        <summary @click.prevent="toggleOpen">検索条件</summary>
        <div class="content-card compact">
          <div
            class="sample-content"
            style="display:flex; gap:16px; align-items:flex-start; position:relative;"
          >
            <div
              style="display:flex; gap:16px; flex-wrap:wrap; align-items:flex-start;"
            >
              <div style="flex-shrink:0;">
                <div style="font-weight:500; color:#666; font-size:14px;">
                  ①避難元の医療機関等施設を検索します
                </div>
                <div style="display:flex;">
                  <div>
                    <div style="display:flex; align-items:center; gap:12px;">
                      <div class="vtf-field" style="width:120px;">
                        <input
                          v-model="searchFilters.oriMunicipName"
                          type="text"
                          placeholder=" "
                          maxlength="30"
                        />
                        <label>市町名</label>
                      </div>
                      <div class="hint">部分一致</div>
                      <div class="vtf-field" style="width:120px;">
                        <input
                          v-model="searchFilters.oriAreaName"
                          type="text"
                          placeholder=" "
                          maxlength="40"
                        />
                        <label>地区名</label>
                      </div>
                      <div class="hint">部分一致</div>
                    </div>
                    <div style="display:flex; align-items:center; gap:12px;">
                      <div style="font-weight:500; color:#666; font-size:12px;">
                        施設種別
                      </div>
                      <select
                        v-model="searchFilters.oriVulnerPplFaType"
                        style="padding:8px 12px; border:1px solid #c7c7c7; border-radius:4px; font-size:12px; min-width:52px;"
                      >
                        <option value="">未選択</option>
                        <option
                          v-for="type in faTypeList"
                          :key="type.code"
                          :value="type.code"
                          >{{ type.name }}</option
                        >
                      </select>
                      <div style="font-weight:500; color:#666; font-size:12px;">
                        施設詳細種別
                      </div>
                      <select
                        v-model="searchFilters.oriFaDetailsType"
                        style="padding:8px 12px; border:1px solid #c7c7c7; border-radius:4px; font-size:12px; max-width:150px;"
                      >
                        <option value="">未選択</option>
                        <option
                          v-for="type in faDetailsTypeList"
                          :key="type.code"
                          :value="type.code"
                          >{{ type.name }}</option
                        >
                      </select>
                    </div>
                    <div style="display:flex; align-items:center; gap:12px;">
                      <div class="vtf-field" style="width:120px;">
                        <input
                          v-model="searchFilters.oriFaName"
                          type="text"
                          placeholder=" "
                          maxlength="40"
                        />
                        <label>施設名</label>
                      </div>
                      <div class="hint">部分一致</div>
                      <div class="vtf-field" style="width:120px;">
                        <input
                          v-model="searchFilters.oriFaAddress"
                          type="text"
                          placeholder=" "
                          maxlength="40"
                        />
                        <label>住所</label>
                      </div>
                      <div class="hint">部分一致</div>
                    </div>
                    <div style="display:flex; align-items:center; gap:12px;">
                      <div style="font-weight:500; color:#666; font-size:12px;">
                        病床数
                      </div>
                      <div class="range-field">
                        <input
                          v-model="searchFilters.oriMaxCapacityFrom"
                          type="text"
                          name="oriMaxCapacityFrom"
                          maxlength="4"
                          autocomplete="off"
                          @input="validateInteger"
                        />
                        <span>〜</span>
                        <input
                          v-model="searchFilters.oriMaxCapacityTo"
                          type="text"
                          name="oriMaxCapacityTo"
                          maxlength="4"
                          autocomplete="off"
                          @input="validateInteger"
                        />
                        <span>人</span>
                      </div>
                    </div>
                    <div style="display:flex; align-items:center; gap:12px;">
                      <div style="font-weight:500; color:#666; font-size:12px;">
                        原発からの直線距離
                      </div>
                      <div class="range-field">
                        <input
                          v-model="searchFilters.oriDistanceFrom"
                          type="text"
                          name="oriDistanceFrom"
                          maxlength="6"
                          autocomplete="off"
                          @input="validateRange"
                        />
                        <span>〜</span>
                        <input
                          v-model="searchFilters.oriDistanceTo"
                          type="text"
                          name="oriDistanceTo"
                          maxlength="6"
                          autocomplete="off"
                          @input="validateRange"
                        />
                        <span>km</span>
                      </div>
                    </div>
                  </div>
                  <div
                    style="display:flex; flex-direction:column; gap:4px; align-items:center; margin-left:20px;"
                  >
                    <div style="font-weight:500; color:#666; font-size:12px;">
                      原発からの方角（複数可）
                    </div>
                    <SelectDirection ref="selectOriDirection" />
                  </div>
                </div>
              </div>

              <!-- 避難先検索 -->
              <div style="flex-shrink:0; margin-left:20px;">
                <div style="font-weight:500; color:#666; font-size:14px;">
                  ②避難先の医療機関等施設を検索します
                </div>
                <div style="display:flex;">
                  <div>
                    <div style="display:flex; align-items:center; gap:12px;">
                      <div style="font-weight:500; color:#666; font-size:12px;">
                        施設種別
                      </div>
                      <select
                        v-model="searchFilters.dstVulnerPplFaType"
                        style="padding:8px 12px; border:1px solid #c7c7c7; border-radius:4px; font-size:12px; min-width:52px;"
                      >
                        <option value="">未選択</option>
                        <option
                          v-for="type in faTypeList"
                          :key="type.code"
                          :value="type.code"
                          >{{ type.name }}</option
                        >
                      </select>
                      <div style="font-weight:500; color:#666; font-size:12px;">
                        施設詳細種別
                      </div>
                      <select
                        v-model="searchFilters.dstFaDetailsType"
                        style="padding:8px 12px; border:1px solid #c7c7c7; border-radius:4px; font-size:12px; max-width:150px;"
                      >
                        <option value="">未選択</option>
                        <option
                          v-for="type in faDetailsTypeList"
                          :key="type.code"
                          :value="type.code"
                          >{{ type.name }}</option
                        >
                      </select>
                    </div>
                    <div style="display:flex; align-items:center; gap:12px;">
                      <div class="vtf-field" style="width:120px;">
                        <input
                          v-model="searchFilters.dstFaName"
                          type="text"
                          placeholder=" "
                          maxlength="40"
                        />
                        <label>施設名</label>
                      </div>
                      <div class="hint">部分一致</div>
                      <div class="vtf-field" style="width:120px;">
                        <input
                          v-model="searchFilters.dstFaAddress"
                          type="text"
                          placeholder=" "
                          maxlength="40"
                        />
                        <label>住所</label>
                      </div>
                      <div class="hint">部分一致</div>
                    </div>
                    <div style="display:flex; align-items:center; gap:12px;">
                      <div style="font-weight:500; color:#666; font-size:12px;">
                        病床数
                      </div>
                      <div class="range-field">
                        <input
                          v-model="searchFilters.dstMaxCapacityFrom"
                          type="text"
                          name="dstMaxCapacityFrom"
                          maxlength="4"
                          autocomplete="off"
                          @input="validateInteger"
                        />
                        <span>〜</span>
                        <input
                          v-model="searchFilters.dstMaxCapacityTo"
                          type="text"
                          name="dstMaxCapacityTo"
                          maxlength="4"
                          autocomplete="off"
                          @input="validateInteger"
                        />
                        <span>人</span>
                      </div>
                    </div>
                    <div style="display:flex; align-items:center; gap:12px;">
                      <div style="font-weight:500; color:#666; font-size:12px;">
                        受入可能者数
                      </div>
                      <div class="range-field">
                        <input
                          v-model="searchFilters.dstAcceptableCapacityFrom"
                          type="text"
                          name="dstAcceptableCapacityFrom"
                          maxlength="4"
                          autocomplete="off"
                          @input="validateInteger"
                        />
                        <span>〜</span>
                        <input
                          v-model="searchFilters.dstAcceptableCapacityTo"
                          type="text"
                          name="dstAcceptableCapacityTo"
                          maxlength="4"
                          autocomplete="off"
                          @input="validateInteger"
                        />
                        <span>人</span>
                      </div>
                    </div>
                    <div style="display:flex; align-items:center; gap:12px;">
                      <div style="font-weight:500; color:#666; font-size:12px;">
                        原発からの直線距離
                      </div>
                      <div class="range-field">
                        <input
                          v-model="searchFilters.dstDistanceFrom"
                          type="text"
                          name="dstDistanceFrom"
                          maxlength="6"
                          autocomplete="off"
                          @input="validateRange"
                        />
                        <span>〜</span>
                        <input
                          v-model="searchFilters.dstDistanceTo"
                          type="text"
                          name="dstDistanceTo"
                          maxlength="6"
                          autocomplete="off"
                          @input="validateRange"
                        />
                        <span>km</span>
                      </div>
                    </div>
                  </div>
                  <div
                    style="display:flex; flex-direction:column; gap:4px; align-items:center; margin-left:20px;"
                  >
                    <div style="font-weight:500; color:#666; font-size:12px;">
                      原発からの方角（複数可）
                    </div>
                    <SelectDirection ref="selectDstDirection" />
                  </div>
                </div>
              </div>
            </div>
            <div style="position:absolute; bottom:8px; right:8px;">
              <v-btn class="btn-primary" @click="clickGetList">
                一覧表示
              </v-btn>
            </div>
          </div>
        </div>
      </details>

      <!-- 一覧部 -->
      <div class="content-card">
        <div
          style="display:flex; justify-content:space-between; align-items:center; margin-bottom:16px; flex-wrap:wrap;"
        >
          <div
            style="display:flex; align-items:center; gap:16px; flex-wrap:wrap;"
          >
            <h2 class="card-title" style="margin:0;">
              避難元避難先一覧（医療機関等）
            </h2>
          </div>
          <v-card-actions>
            <v-btn class="btn-primary" @click="exportExcel">
              Excel出力
            </v-btn>
          </v-card-actions>
        </div>
        <div class :style="{ height: tableHeight + 'px', overflow: 'auto' }">
          <table class="table adjustment-table fsv-table">
            <thead>
              <tr>
                <th colspan="10">避難元医療機関等</th>
                <th colspan="10">避難先医療機関等</th>
              </tr>
              <tr>
                <th
                  rowspan="2"
                  style="cursor:pointer;"
                  @click="sortBy('ori_municip_name')"
                >
                  市町名
                  <span v-if="sortKey === 'ori_municip_name'">
                    <i
                      :class="[
                        'fas',
                        sortOrder === 'asc' ? 'fa-sort-up' : 'fa-sort-down'
                      ]"
                    ></i>
                  </span>
                  <span v-else>
                    <i class="fas fa-sort"></i>
                  </span>
                </th>
                <th
                  rowspan="2"
                  style="cursor:pointer;"
                  @click="sortBy('ori_area_name')"
                >
                  地区名
                  <span v-if="sortKey === 'ori_area_name'">
                    <i
                      :class="[
                        'fas',
                        sortOrder === 'asc' ? 'fa-sort-up' : 'fa-sort-down'
                      ]"
                    ></i>
                  </span>
                  <span v-else>
                    <i class="fas fa-sort"></i>
                  </span>
                </th>
                <th
                  rowspan="2"
                  style="cursor:pointer;"
                  @click="sortBy('ori_vulner_ppl_fa_type_val')"
                >
                  施設種別
                  <span v-if="sortKey === 'ori_vulner_ppl_fa_type_val'">
                    <i
                      :class="[
                        'fas',
                        sortOrder === 'asc' ? 'fa-sort-up' : 'fa-sort-down'
                      ]"
                    ></i>
                  </span>
                  <span v-else>
                    <i class="fas fa-sort"></i>
                  </span>
                </th>
                <th
                  rowspan="2"
                  style="cursor:pointer;"
                  @click="sortBy('ori_fa_details_type_val')"
                >
                  施設<br />詳細種別
                  <span v-if="sortKey === 'ori_fa_details_type_val'">
                    <i
                      :class="[
                        'fas',
                        sortOrder === 'asc' ? 'fa-sort-up' : 'fa-sort-down'
                      ]"
                    ></i>
                  </span>
                  <span v-else>
                    <i class="fas fa-sort"></i>
                  </span>
                </th>
                <th
                  rowspan="2"
                  style="cursor:pointer;"
                  @click="sortBy('ori_fa_name')"
                >
                  施設名
                  <span v-if="sortKey === 'ori_fa_name'">
                    <i
                      :class="[
                        'fas',
                        sortOrder === 'asc' ? 'fa-sort-up' : 'fa-sort-down'
                      ]"
                    ></i>
                  </span>
                  <span v-else>
                    <i class="fas fa-sort"></i>
                  </span>
                </th>
                <th
                  rowspan="2"
                  style="cursor:pointer;"
                  @click="sortBy('ori_fa_name_kana')"
                >
                  フリガナ
                  <span v-if="sortKey === 'ori_fa_name_kana'">
                    <i
                      :class="[
                        'fas',
                        sortOrder === 'asc' ? 'fa-sort-up' : 'fa-sort-down'
                      ]"
                    ></i>
                  </span>
                  <span v-else>
                    <i class="fas fa-sort"></i>
                  </span>
                </th>
                <th rowspan="2">住所</th>
                <th rowspan="2">病床数</th>
                <th colspan="2">原発からの</th>
                <th
                  rowspan="2"
                  style="cursor:pointer;"
                  @click="sortBy('dst_municip_name')"
                >
                  市町名
                  <span v-if="sortKey === 'dst_municip_name'">
                    <i
                      :class="[
                        'fas',
                        sortOrder === 'asc' ? 'fa-sort-up' : 'fa-sort-down'
                      ]"
                    ></i>
                  </span>
                  <span v-else>
                    <i class="fas fa-sort"></i>
                  </span>
                </th>
                <th
                  rowspan="2"
                  style="cursor:pointer;"
                  @click="sortBy('dst_vulner_ppl_fa_type_val')"
                >
                  施設種別
                  <span v-if="sortKey === 'dst_vulner_ppl_fa_type_val'">
                    <i
                      :class="[
                        'fas',
                        sortOrder === 'asc' ? 'fa-sort-up' : 'fa-sort-down'
                      ]"
                    ></i>
                  </span>
                  <span v-else>
                    <i class="fas fa-sort"></i>
                  </span>
                </th>
                <th
                  rowspan="2"
                  style="cursor:pointer;"
                  @click="sortBy('dst_fa_details_type_val')"
                >
                  施設<br />詳細種別
                  <span v-if="sortKey === 'dst_fa_details_type_val'">
                    <i
                      :class="[
                        'fas',
                        sortOrder === 'asc' ? 'fa-sort-up' : 'fa-sort-down'
                      ]"
                    ></i>
                  </span>
                  <span v-else>
                    <i class="fas fa-sort"></i>
                  </span>
                </th>
                <th
                  rowspan="2"
                  style="cursor:pointer;"
                  @click="sortBy('dst_fa_name')"
                >
                  施設名
                  <span v-if="sortKey === 'dst_fa_name'">
                    <i
                      :class="[
                        'fas',
                        sortOrder === 'asc' ? 'fa-sort-up' : 'fa-sort-down'
                      ]"
                    ></i>
                  </span>
                  <span v-else>
                    <i class="fas fa-sort"></i>
                  </span>
                </th>
                <th
                  rowspan="2"
                  style="cursor:pointer;"
                  @click="sortBy('dst_fa_name_kana')"
                >
                  フリガナ
                  <span v-if="sortKey === 'dst_fa_name_kana'">
                    <i
                      :class="[
                        'fas',
                        sortOrder === 'asc' ? 'fa-sort-up' : 'fa-sort-down'
                      ]"
                    ></i>
                  </span>
                  <span v-else>
                    <i class="fas fa-sort"></i>
                  </span>
                </th>
                <th rowspan="2">住所</th>
                <th rowspan="2">病床数</th>
                <th rowspan="2">受入可能者数</th>
                <th colspan="2">原発からの</th>
              </tr>
              <tr>
                <th>方角</th>
                <th>直線距離</th>
                <th>方角</th>
                <th>直線距離</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="data in sortedFacilities" :key="data.key">
                <td>{{ data.ori_municip_name }}</td>
                <td>{{ data.ori_area_name }}</td>
                <td>{{ data.ori_vulner_ppl_fa_type_val }}</td>
                <td>{{ data.ori_fa_details_type_val }}</td>
                <td>{{ data.ori_fa_name }}</td>
                <td>{{ data.ori_fa_name_kana }}</td>
                <td>{{ data.ori_fa_address }}</td>
                <td>{{ data.ori_max_capacity }}</td>
                <td>{{ data.ori_direction_from_npp }}</td>
                <td>{{ data.ori_distance_from_npp }} km</td>
                <td>{{ data.dst_municip_name }}</td>
                <td>{{ data.dst_vulner_ppl_fa_type_val }}</td>
                <td>{{ data.dst_fa_details_type_val }}</td>
                <td>{{ data.dst_fa_name }}</td>
                <td>{{ data.dst_fa_name_kana }}</td>
                <td>{{ data.dst_fa_address }}</td>
                <td>{{ data.dst_max_capacity }}</td>
                <td>{{ data.dst_acceptable_capacity }}</td>
                <td>{{ data.dst_direction_from_npp }}</td>
                <td>{{ data.dst_distance_from_npp }} km</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
    <ErrorDialog ref="errorDialog" />
    <v-overlay :value="overlay" opacity="1" color="white">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import ExcelJS from "exceljs";
import messageUtils from "@/mixins/message-utils";
import { ErrorTodoMessages } from "@/js/constants/error-messages";
import { RepositoryFactory } from "@/js/repository/RepositoryFactory";
import { ScreenId } from "@/js/value-objects/screen-id";

const adjustmentSystemRepository = RepositoryFactory.get("adjustmentSystem");
const facilitySearchVulRepository = RepositoryFactory.get("facilitySearchVul");

const LIST_MAX_HEIGHT = 598;
const LIST_MIN_HEIGHT = 300;

export default {
  name: "facilitySearchVul",
  mixins: [messageUtils],
  components: {
    ErrorMessage: () => import("@/components/ErrorMessage"),
    ErrorDialog: () => import("@/components/adjustment/AdErrorDialog"),
    SelectDirection: () => import("@/components/adjustment/SelectDirection")
  },
  data: () => ({
    overlay: false,
    isOpen: true,
    isAuth: false,
    searchFilters: {
      oriMunicipName: "",
      oriAreaName: "",
      oriVulnerPplFaType: "",
      oriFaDetailsType: "",
      oriFaName: "",
      oriFaAddress: "",
      oriMaxCapacityFrom: null,
      oriMaxCapacityTo: null,
      oriDistanceFrom: null,
      oriDistanceTo: null,
      dstMunicipName: "",
      dstVulnerPplFaType: "",
      dstFaDetailsType: "",
      dstFaName: "",
      dstFaAddress: "",
      dstMaxCapacityFrom: null,
      dstMaxCapacityTo: null,
      dstAcceptableCapacityFrom: null,
      dstAcceptableCapacityTo: null,
      dstDistanceFrom: null,
      dstDistanceTo: null
    },
    sortKey: "",
    sortOrder: "asc",
    faTypeList: [],
    faDetailsTypeList: [],
    facilityList: []
  }),

  computed: {
    // 検索条件表示非表示の時の一覧の高さ調整
    tableHeight() {
      return this.isOpen ? LIST_MIN_HEIGHT : LIST_MAX_HEIGHT;
    },
    // 一覧のソート
    sortedFacilities() {
      const filtered = this.facilityList;
      if (!this.sortKey) return filtered;

      return [...filtered].sort((a, b) => {
        const aVal = a[this.sortKey];
        const bVal = b[this.sortKey];
        const modifier = this.sortOrder === "asc" ? 1 : -1;

        if (aVal < bVal) return -1 * modifier;
        if (aVal > bVal) return 1 * modifier;
        return 0;
      });
    }
  },

  async mounted() {
    await this.initialize();
  },

  methods: {
    // 初期処理
    async initialize() {
      this.clearMessage();
      this.overlay = true;
      try {
        this.clearSort();
        /* 権限取得 */
        const payload = {
          faTypeFlg: true,
          faDetailsTypeFlg: true
        };
        await adjustmentSystemRepository
          .list(ScreenId.SF4101, payload)
          .then(response => {
            this.isAuth = response.data.isAuth;
            this.faTypeList = response.data.faTypeList;
            this.faDetailsTypeList = response.data.faDetailsTypeList;
          })
          .catch(e => {
            this.handleUpdateError(e);
          });
      } catch (error) {
        this.handleUpdateError(error);
        console.error("ユーザーの権限取得に失敗しました:", error);
      } finally {
        this.overlay = false;
      }
    },
    // 検索条件開閉
    toggleOpen() {
      this.isOpen = !this.isOpen;
    },
    validateRange(e) {
      const key = e.target.name;
      let txtValue = e.target.value.replace(/[^0-9.]/g, "");
      let value = parseFloat(txtValue);
      if (isNaN(value)) {
        this.searchFilters[key] = txtValue;
      }
      if (value < 0.0) txtValue = 0.0;
      if (value > 9999.9) txtValue = 9999.9;
      this.searchFilters[key] = txtValue;
    },
    validateInteger(e) {
      const key = e.target.name;
      let txtValue = e.target.value.replace(/[^0-9]/g, "");
      let value = parseInt(txtValue);
      if (isNaN(value)) {
        this.searchFilters[key] = txtValue;
        return;
      }
      if (value < 0) txtValue = 0;
      if (value > 9999) txtValue = 9999;
      this.searchFilters[key] = txtValue;
    },
    // 一覧のソート処理
    sortBy(key) {
      if (this.sortKey === key) {
        this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
      } else {
        this.sortKey = key;
        this.sortOrder = "asc";
      }
    },
    clearSort() {
      this.sortKey = "";
      this.sortOrder = "asc";
    },
    async clickGetList() {
      this.clearMessage();
      await this.getList();
    },
    // 避難元避難先一覧取得
    async getList() {
      this.overlay = true;
      try {
        this.clearSort();
        const oriDirections = await this.$refs.selectOriDirection.getSelectDirection();
        const dstDirections = await this.$refs.selectDstDirection.getSelectDirection();
        const payload = {
          oriMunicipName: this.searchFilters.oriMunicipName,
          oriAreaName: this.searchFilters.oriAreaName,
          oriVulnerPplFaType: this.searchFilters.oriVulnerPplFaType,
          oriFaDetailsType: this.searchFilters.oriFaDetailsType,
          oriFaName: this.searchFilters.oriFaName,
          oriFaAddress: this.searchFilters.oriFaAddress,
          oriMaxCapacityFrom: this.searchFilters.oriMaxCapacityFrom,
          oriMaxCapacityTo: this.searchFilters.oriMaxCapacityTo,
          oriDistanceFrom: this.searchFilters.oriDistanceFrom,
          oriDistanceTo: this.searchFilters.oriDistanceTo,
          oriDirectionList: oriDirections,
          dstVulnerPplFaType: this.searchFilters.dstVulnerPplFaType,
          dstFaDetailsType: this.searchFilters.dstFaDetailsType,
          dstFaName: this.searchFilters.dstFaName,
          dstFaAddress: this.searchFilters.dstFaAddress,
          dstMaxCapacityFrom: this.searchFilters.dstMaxCapacityFrom,
          dstMaxCapacityTo: this.searchFilters.dstMaxCapacityTo,
          dstAcceptableCapacityFrom: this.searchFilters
            .dstAcceptableCapacityFrom,
          dstAcceptableCapacityTo: this.searchFilters.dstAcceptableCapacityTo,
          dstDistanceFrom: this.searchFilters.dstDistanceFrom,
          dstDistanceTo: this.searchFilters.dstDistanceTo,
          dstDirectionList: dstDirections
        };
        await facilitySearchVulRepository
          .list(ScreenId.SF4101, payload)
          .then(response => {
            this.facilityList = response.data.results;
            this.isOpen = false;
          })
          .catch(e => {
            this.handleUpdateError(e);
          });
      } catch (error) {
        this.handleUpdateError(error);
        console.error(
          "避難元避難先一覧（医療機関等）の取得に失敗しました:",
          error
        );
      } finally {
        this.overlay = false;
      }
    },
    // EXCEL出力
    async exportExcel() {
      this.overlay = true;
      try {
        if (!this.facilityList.length > 0) {
          await this.$refs.errorDialog.open(ErrorTodoMessages.ERWE48001);
          return;
        }

        /* タイムスタンプ算出 */
        let now = new Date();
        let year = now.getFullYear();
        let month = ("00" + (now.getMonth() + 1)).slice(-2);
        let day = ("00" + now.getDate()).slice(-2);
        let hour = ("00" + now.getHours()).slice(-2);
        let minute = ("00" + now.getMinutes()).slice(-2);
        let timeStamp = year + month + day + hour + minute;
        let timeStamp2 =
          year + "/" + month + "/" + day + " " + hour + ":" + minute;

        // 固定のExcelファイルを取得（publicフォルダに配置されていると仮定）
        const response = await fetch("/template/facility_search_vul_list.xlsx");
        const arrayBuffer = await response.arrayBuffer();

        const workbook = new ExcelJS.Workbook();
        await workbook.xlsx.load(arrayBuffer);

        const worksheet = workbook.getWorksheet(1); // 最初のシートを取得

        // 罫線スタイルを定義
        const borderStyle = {
          style: "thin",
          color: { argb: "FF000000" }
        };

        //5行目まではヘッダー
        const headerRowCount = 5;
        let rowNo = headerRowCount;
        this.facilityList.forEach(data => {
          rowNo++;
          const row = worksheet.insertRow(rowNo, [
            rowNo - headerRowCount,
            data.ori_municip_name,
            data.ori_area_name,
            data.ori_vulner_ppl_fa_type_val,
            data.ori_fa_details_type_val,
            data.ori_fa_name,
            data.ori_fa_name_kana,
            data.ori_fa_address,
            Number(data.ori_max_capacity),
            data.ori_direction_from_npp,
            data.ori_distance_from_npp + " km",
            data.dst_municip_name,
            data.dst_vulner_ppl_fa_type_val,
            data.dst_fa_details_type_val,
            data.dst_fa_name,
            data.dst_fa_name_kana,
            data.dst_fa_address,
            Number(data.dst_max_capacity),
            Number(data.dst_acceptable_capacity),
            data.dst_direction_from_npp,
            data.dst_distance_from_npp + " km"
          ]);

          // 各セルに罫線を設定
          row.eachCell(cell => {
            cell.border = {
              top: borderStyle,
              left: borderStyle,
              bottom: borderStyle,
              right: borderStyle
            };
          });
        });

        const cell = worksheet.getCell("U2");
        cell.value = "出力日時：" + timeStamp2;

        // 編集済みファイルをダウンロード
        const editedBuffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([editedBuffer], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });

        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "避難元避難先一覧（医療機関等）_" + timeStamp + ".xlsx";
        link.click();
      } catch (error) {
        console.error("EXCEL出力に失敗しました:", error);
      } finally {
        this.overlay = false;
      }
    }
  }
};
</script>
